export enum GamIconSize {
  SMALL = '14px',
  NORMAL = '16px',
  LARGE = '18px',
  X_LARGE = '24px',
}

export enum GamIconSpecialSize {
  PIN = '20px',
  MY_LOCATION = '36px',
  TOURNAMENT = '68px',
}

export enum GamIconName {
  UNKNOWN = 'unknown',
  MAP_2D = '2d-map',
  MAP_3D = '3d-map',
  ADMIN = 'admin',
  APPLE = 'apple',
  APPLEPAY = 'applepay',
  ARROW_DOWN = 'arrow-down',
  ARROW_LEFT = 'arrow-left',
  ARROW_RIGHT = 'arrow-right',
  ARROW_RIGHT_END = 'arrow-right-end',
  CHEVRON_LEFT = 'chevron-left',
  CHEVRON_RIGHT = 'chevron-right',
  ACCCOUNT_SETTINGS = 'account-settings',
  ARROW_UP = 'arrow-up',
  BELL_EMPTY = 'bell-empty',
  BELL = 'bell',
  BIGMAC = 'bigmac',
  BIGMAC_EMPTY = 'bigmac-empty',
  BIRD = 'bird',
  BULLET_LIST = 'bullet-list',
  BULLET_LIST_EMPTY = 'bullet-list-empty',
  CAMERA = 'camera',
  CHECK = 'check',
  PAUSE = 'pause',
  PLAY = 'play',
  PLAY_EMPTY = 'play-empty',
  PLAY_OUTLINE = 'play-outline',
  PUZZLE = 'puzzle',
  PUZZLE_GRID = 'puzzle-grid',
  CIRCLES_GRID = 'circles-grid',
  CHESS_CLOCK = 'chess-clock',
  CHESS_COM = 'chess-com',
  CHESS_SET = 'chess-set',
  CHESS_TABLE = 'chess-table',
  CLUB = 'club',
  COFFEE = 'coffee',
  COMPASS = 'compass',
  CORNER = 'corner',
  CROWN = 'crown',
  DOTS_H = 'dots-h',
  DOTS_H_EMPTY = 'dots-h-empty',
  DOTS_V = 'dots-v',
  DOUBLE_CHECK = 'double-check',
  DOWN = 'down',
  DOUBLE_DOWN = 'double-down',
  EDIT = 'edit',
  ENVELOPE = 'envelope',
  EXPLORE = 'explore',
  EXPLORE_EMPTY = 'explore-empty',
  FAST = 'fast',
  FAST_EMPTY = 'fast-empty',
  FAST_PAUSE = 'fast-pause',
  FEED = 'feed',
  FEMALE = 'female',
  FIDE = 'fide',
  FILTER = 'filter',
  FILTER_LEGIBLE = 'filter-legible',
  FILTER_APPLIED = 'filter-applied',
  TILDE = 'tilde',
  GAMBIT = 'gambit',
  GAMBIT_EMPTY = 'gambit-empty',
  GAMBIT_HALF = 'gambit-half',
  GIANT_CHESS = 'giant-chess',
  GOOGLE = 'google',
  HAMBURGER = 'hamburger',
  HANDSHAKE = 'handshake',
  HANDSHAKE_EMPTY = 'handshake-empty',
  HANDSHAKE_HALF_LEFT = 'handshake-half-left',
  HANDSHAKE_HALF_RIGHT = 'handshake-half-right',
  HEART = 'heart',
  HEART_EMPTY = 'heart-empty',
  HOUSE = 'house',
  IMAGE = 'image',
  INSTAGRAM = 'ig',
  INVITE = 'invite',
  INVITE_EMPTY = 'invite-empty',
  INVITE_PLAYER = 'invite-player',
  LAST_TIME = 'last-time',
  LICHESS = 'lichess',
  LIKE = 'like',
  LIST = 'list',
  LOADING = 'loading',
  LOCATION = 'location',
  LOCATION_EMPTY = 'location-empty',
  LOCK = 'lock',
  LOGO = 'logo',
  MAP = 'map',
  MASTERCARD = 'mastercard',
  MASTERCARD_SQUARE = 'mastercard-square',
  MESSAGE = 'message',
  MESSAGE_EMPTY = 'message-empty',
  MINUS = 'minus',
  MUTUAL = 'mutual',
  NAVIGATE = 'navigate',
  NAVIGATE_EMPTY = 'navigate-empty',
  MUTUAL_EMPTY = 'mutual-empty',
  PROFILE = 'my-profile',
  PROFILE_EMPTY = 'my-profile-empty',
  PROFILE_STROKE = 'my-profile-stroke',
  PROFILE_INVERTED = 'my-profile-inverted',
  NOTIFICATIONS = 'notifications',
  NOTIFICATIONS_EMPTY = 'notifications-empty',
  OWNER = 'owner',
  OWNER_EMPTY = 'owner-empty',
  PAGE_MENU = 'page-menu',
  PAWN = 'pawn',
  PAWN_EMPTY = 'pawn-empty',
  PIN = 'pin',
  PIN_EMPTY = 'pin-empty',
  PLUS = 'plus',
  QR_CODE = 'qr-code',
  REFRESH = 'refresh',
  SWAP_COLOURS = 'swap-colours',
  STOP = 'stop',
  SHUFFLE = 'shuffle',
  RESULTS = 'results',
  RESULTS_EMPTY = 'results-empty',
  ROUTE = 'route',
  SMALL_ARROW_UP = 's-arrow-up',
  SMALL_ARROW_LEFT = 's-arrow-left',
  SMALL_ARROW_RIGHT = 's-arrow-right',
  SMALL_ARROW_DOWN = 's-arrow-down',
  SEARCH = 'search',
  SHARE = 'share',
  SPARK = 'spark',
  SPARK_CURSOR = 'spark-cursor',
  SPARK_CURSOR_EMPTY = 'spark-cursor-empty',
  SPARK_EMPTY = 'spark-empty',
  STAR = 'star',
  STAR_EMPTY = 'star-empty',
  SWORDS = 'swords',
  SETTINGS_GEAR = 'settings-gear',
  SETTINGS_GEAR_EMPTY = 'settings-gear-empty',
  STREET_LOCATION = 'street-location',
  TAP = 'tap',
  TARGET = 'target',
  TEXT_SIZE = 'text-size',
  THUMBS = 'thumbs',
  TIME = 'time',
  TOOLTIP = 'tooltip',
  TRASH = 'trash',
  TUNE = 'tune',
  VENUE = 'venue',
  WARNING = 'warning',
  WALK = 'walk',
  WALK_MARK = 'walk-mark',
  X_CLOSE = 'x-close',
  XS_ARROW_DOWN = 'xs-arrow-down',
  XS_ARROW_LEFT = 'xs-arrow-left',
  XS_ARROW_RIGHT = 'xs-arrow-right',
  XS_ARROW_UP = 'xs-arrow-up',
  AT = 'at',
  UPLOAD_FILE = 'upload-file',
}

export enum GamIconSpecialName {
  EVENT = 'pin-event',
  TOURNAMENT = 'pin-tournament',
  MY_LOCATION = 'pin-my-location',
  BADGE_MATCH = 'badge-match',
  KEY_UP = 'keyboard-up',
  KEY_DOWN = 'keyboard-down',
  SELECTED_PIN = 'selected-pin',
}
